import { render, staticRenderFns } from "./EmployeeTrainingDetail.vue?vue&type=template&id=de9a2264&"
import script from "./EmployeeTrainingDetail.vue?vue&type=script&lang=ts&"
export * from "./EmployeeTrainingDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports